import React from 'react';

const categories = [
  "Ferretería general", "Electricidad", "Fontanería y baños", "Seguridad industrial",
  "Herramientas", "Tuberías y conexiones", "Lubricantes y selladores", "Pintura y acabados",
  "Accesorios de PVC y acero", "Repuestos industriales"
];

function Categories() {
  return (
    <section id="categories" className="container py-5">
      <h3>Categorías de Productos</h3>
      <div className="row">
        <div className="col">
            <ul>
                {categories.map((cat, i) => <li key={i}>{cat}</li>)}
            </ul>
        </div>
      </div>
      
    </section>
  );
}

export default Categories;
